import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const PendingApprovalsPanel = ({ pendingApprovals }) => {
  const items = [
    { key: 'teams', label: 'Club Teams', icon: 'Users', color: 'text-warning' },
    { key: 'players', label: 'Players', icon: 'User', color: 'text-accent' },
    { key: 'coaches', label: 'Coaches', icon: 'GraduationCap', color: 'text-primary' },
    { key: 'regionalTeams', label: 'Regional Teams', icon: 'Map', color: 'text-secondary' },
    { key: 'regions', label: 'Region Associations', icon: 'Building2', color: 'text-error' },
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6 card-shadow h-full">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Pending Approvals</h3>
          <p className="text-sm text-muted-foreground">
            {pendingApprovals?.total || 0} items awaiting review
          </p>
        </div>
        <Link
          to="/approvals"
          className="text-sm text-primary hover:underline flex items-center gap-1"
        >
          Review all
          <Icon name="ArrowRight" size={14} />
        </Link>
      </div>
      <div className="space-y-3">
        {items.map((item) => (
          <div
            key={item.key}
            className="flex items-center justify-between p-3 rounded-lg bg-muted/30 border border-border"
          >
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-background flex items-center justify-center">
                <Icon name={item.icon} size={18} className={item.color} />
              </div>
              <span className="text-sm font-medium text-foreground">{item.label}</span>
            </div>
            <span className={`text-lg font-bold ${pendingApprovals?.[item.key] ? item.color : 'text-muted-foreground'}`}>
              {pendingApprovals?.[item.key] || 0}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PendingApprovalsPanel;
